import { render, staticRenderFns } from "./LittleGateDescription.vue?vue&type=template&id=7d4b3f71&scoped=true"
import script from "./LittleGateDescription.vue?vue&type=script&lang=ts"
export * from "./LittleGateDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4b3f71",
  null
  
)

export default component.exports